module.exports = __webpack_public_path__ + "img/banner3_2_th.e87566f6.png";